import actions from '../actions/quotes';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
